module.exports = __webpack_public_path__ + "img/back2Top.3ee7a52.webp";